import React from 'react';
import type { MultiFileUploadV2FileItem as FileItem } from 'shared-components';
import { IApplicantOfferRequirementTask } from 'types';
import { uploadStaffInternalFileWithProgress } from '@/api/api';
import { MultiFileUploadModal } from './MultiFileUploadModal';
import { useTranslation } from "react-i18next";

interface InternalDocumentUploadModalProps {
  requirement: IApplicantOfferRequirementTask;
  isOpen: boolean;
  onClose: () => void;
  docKey: string;
  onProceed: (files: FileItem[], deletedS3Keys?: string[]) => void;
  uploadedSuccessfully: boolean;
  fileUploadError: string | null;
  existingFiles?: { s3Keys: string[]; urls?: string[] };
}

export const InternalDocumentUploadModal: React.FC<InternalDocumentUploadModalProps> = ({
  requirement,
  isOpen,
  onClose,
  docKey,
  onProceed,
  uploadedSuccessfully,
  fileUploadError,
  existingFiles,
}) => {
    const { t } = useTranslation('common');
        return <MultiFileUploadModal
        id={`internal-upload-${requirement.id}`}
        title={t('common:uploadFile')}
        isOpen={isOpen}
        onClose={onClose}
        onProceed={onProceed}
        uploadedSuccessfully={uploadedSuccessfully}
        fileUploadError={fileUploadError}
        deletedSuccessfully={false}
        uploadFn={({ file, idToken, university, applicantId, uploadConf, onProgress, signal }) =>
          uploadStaffInternalFileWithProgress({ file, idToken, university, applicantId, uploadConf, onProgress, signal })
        }
        documentConfig={{ docKey }}
        existingFiles={existingFiles}
      />;
      };
